import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { assetTreeKey } from '@services/useAssetTreeQuery';

import { type IUseUpdateTreeData } from '../model/location';

const updateTreeFn = (data: IUseUpdateTreeData) => {
  return apiClient.post(`${APP_API_URL}locations/update-asset-tree`, data);
};

export const useUpdateTreeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTreeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: assetTreeKey() });
    },
  });
};
